import Proptypes from "prop-types";
import React from "react";

const MessageIcon = ({ size = 24, color = "#000091" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM20 7.238L12.072 14.338L4 7.216V19H20V7.238ZM4.511 5L12.061 11.662L19.502 5H4.511Z"
      fill={color}
    />
  </svg>
);

MessageIcon.propTypes = {
  color: Proptypes.string,
  size: Proptypes.number,
};

export default MessageIcon;
